import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import images from "../../../Assets/Images";
import "./SideBarActivity.css";
import { CSidebar, CSidebarHeader } from '@coreui/react';
import LanguageContext from '../../../Utiliz/LanguageContext';
import { useDispatch, useSelector } from "react-redux";
import { addBasicMode } from "../../../Redux/BasicModeReducer";
import Dropdown from 'react-bootstrap/Dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlay, faPause } from '@fortawesome/free-solid-svg-icons';
import { addSideBarActiveButton, addSideBarActiveState } from "../../../Redux/SidebarActiveButtonReducer";
import { addActiveMuscleRow, addBasicModeSubMuscle, addIsPlaying, addMuscleName, addSetProgressPlayPause, addSliderChangevalue } from "../../../Redux/CommonReducer";
import { addAllPaused, addDeepBackForearmVisibility, addDeepFrontForearmVisibility, addDeepMusclePalm, addMusclePalmVisibility, addMuscleThumbVisibility, addSelectedMuscleGroup, addSuperficialBackForearmVisibility, addSuperficialFrontForearmVisibility } from "../../../Redux/AreaSelectionModeReducer";
import 'react-range-slider-input/dist/style.css';
import TipsModal from "../../TipsModal/TipsModal";
import LoadingContext from './../../../Utiliz/LoadingContext';
import { add } from "three/webgpu";

const SideBarActivity = () => {
  const dispatch = useDispatch();
  const [activeButton, setActiveButton] = useState('basicmode');
  const [playingVideos, setPlayingVideos] = useState({});
  const { language } = useContext(LanguageContext);
  const setprogressplaypause = useSelector((state) => state.CommonReducer.setprogressplaypause);
  const [selectAll1, setSelectAll1] = useState(true);
  const [selectAllSuperficialFront, setSelectAllSuperficialFront] = useState(true);
  const [selectAllDeepFront, setSelectAllDeepFront] = useState(true);



  const muscleContent = {
    superficial_front_forearm: {
      names: {
        en: "Superficial Muscle Of Front Of Forearm",
        ko: "팔뚝 앞쪽의 표면 근육"
      },
      muscles: [
        { en: "Pronator_Teres", ko: "원엎침근" },
        { en: "Flexor_Carpi_Radialis", ko: "노쪽손목굽힘근" },
        { en: "Palmaris_Longus", ko: "긴손바닥근" },
        { en: "Flexor_Carpi_Ulnaris, FCU", ko: "자쪽손목굽힘근" },
        { en: "Flexor_Digitorum_Superficialis", ko: "얕은손가락굽힘근" }
      ]
    },
    deep_front_forearm: {
      names: {
        en: "Deep Muscles Of Front Of Forearm",
        ko: "팔뚝 앞쪽의 깊은 근육"
      },
      muscles: [
        { en: "Pronator_Quadratus_Muscle", ko: " 네모엎침근" },
        { en: "Flexor_Digitorum_Profundus", ko: "깊은손가락굽힌근" },
        { en: "Flexor_Pollicis_Longus, FPL", ko: "긴엄지굽힘근" }
      ]
    },
    superficial_back_forearm: {
      names: {
        en: "Superficial Muscles Of Back Of Forearm",
        ko: "팔뚝 뒤쪽의 표면 근육"
      },
      muscles: [
        { en: "Extensor_Digitorum_Muscle", ko: "손가락폄근" },
        { en: "Extensor_Digiti_Minimi", ko: "새끼폄근" },
        { en: "Extensor_Carpi_Ulnaris", ko: "자쪽손목폄근" },
        { en: "Brachioradialis_Muscle", ko: "위팔노근" },
        { en: "Extensor_Carpi_Radialis_Longus", ko: "긴노쪽손목폄근" },
        { en: "Extensor_Carpi_Radialis_Brevis", ko: "짧은노쪽손목폄근" },

      ]
    },
    deep_back_forearm: {
      names: {
        en: "Deep Muscles Of Back Of Forearm",
        ko: "팔뚝 뒤쪽의 깊은 근육"
      },
      muscles: [
        { en: "Supinator_Muscle", ko: "손뒤침근" },
        { en: "Extensor_Indices [Proprius]", ko: "집게폄근" },
        { en: "Abductor_Pollicis_Longus, APL", ko: "긴엄지벌림근" },
        { en: "Extensor_Pollicis_Brevis, EPB", ko: "짧은엄지폄근" },
        { en: "Extensor_Pollicis_Longus_Muscle, EPL", ko: "긴엄지폄근" }
      ]
    },
    muscles_thumb: {
      names: {
        en: "Muscles Of The Thumb",
        ko: "엄지손가락의 근육"
      },
      muscles: [
        { en: "Opponens_Pollicis", ko: "엄지반대근" },
        { en: "Flexor_Pollicis_Brevis", ko: "짧은엄지굽힘근" },
        { en: "Abductor_Pollicis_Brevis", ko: "짧은엄지벌림근" },
        { en: "Adductor_Pollicis_Muscle", ko: "엄지모음근" },
      ]
    },
    muscles_palm: {
      names: {
        en: "Muscles Of The Palm",
        ko: "손바닥 근육"
      },
      muscles: [
        { en: "Palmaris_Brevis", ko: "짧은손바닥근" },
        { en: "Abductor_Digiti_Minimi", ko: "새끼벌림근" },
        { en: "Flexor_Digiti_Minimi_Brevis", ko: "짧은새끼굽힘근" },
        { en: "Opponens_Digiti_Minimi", ko: "새끼맞섬근" },

      ]
    },
    deep_muscles_palm: {
      names: {
        en: "Deep Muscles Of The Palm",
        ko: "손바닥의 깊은 근육"
      },
      muscles: [
        { en: "Lumbricals", ko: "벌레근" },
        { en: "Dorsal_Interrosei, DI", ko: "등쪽뼈사이근" },
        { en: "Palmar_Interossei", ko: "바닥쪽뼈사이근" },

      ]
    }
  };
  const [selectAllSuperficialBack, setSelectAllSuperficialBack] = useState(true);
  const [selectAllDeepBack, setSelectAllDeepBack] = useState(true);
  const [selectAllThumb, setSelectAllThumb] = useState(true);
  const [selectAllPalm, setSelectAllPalm] = useState(true);
  const [selectAllDeepPalm, setSelectAllDeepPalm] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [imageSrc, setImageSrc] = useState('');
  const [isTipsClicked, setIsTipsClicked] = useState(false);
  const [tipsContent, setTipsContent] = useState([]);
  const { loading } = useContext(LoadingContext);
  const [dropdownOpen, setDropdownOpen] = useState({});


  const [checkedItems2, setCheckedItems2] = useState({
    superficial_front_forearm: true,
    deep_front_forearm: true,
    superficial_back_forearm: true,
    deep_back_forearm: true,
    muscles_thumb: true,
    muscles_palm: true,
    deep_muscles_palm: true,
  });

  const muscleNames = {
    superficial_front_forearm: {
      en: "Superficial Muscle Of Front Of Forearm",
      ko: "팔뚝 앞쪽의 표면 근육"
    },
    deep_front_forearm: {
      en: "Deep Muscles Of Front Of Forearm",
      ko: "팔뚝 앞쪽의 깊은 근육"
    },
    superficial_back_forearm: {
      en: "Superficial Muscles Of Back Of Forearm",
      ko: "팔뚝 뒤쪽의 표면 근육"
    },
    deep_back_forearm: {
      en: "Deep Muscles Of Back Of Forearm",
      ko: "팔뚝 뒤쪽의 깊은 근육"
    },
    muscles_thumb: {
      en: "Muscles Of The Thumb",
      ko: "엄지손가락의 근육"
    },
    muscles_palm: {
      en: "Muscles Of The Palm",
      ko: "손바닥 근육"
    },
    deep_muscles_palm: {
      en: "Deep Muscles Of The Palm",
      ko: "손바닥의 깊은 근육"
    }
  };

  //area selection mode checked items 
  const [superficialMuscleFrontCheckedItems, setSuperficialMuscleFrontCheckedItems] = useState({
    pronator_teres: true,
    flexor_carpi_radialis: true,
    palmar_longus_muscle: true,
    flexor_carpi_ulnaris: true,
    flexor_digitorum_super_cialis: true

  })

  const superficialmuscleNames = {
    pronator_teres: {
      en: "Pronator Teres",
      ko: "원엎침근"
    },
    flexor_carpi_radialis: {
      en: "Flexor Carpi Radialis",
      ko: "노쪽손목굽힘근"
    },
    palmar_longus_muscle: {
      en: "Palmaris Longus",
      ko: "긴손바닥근"
    },
    flexor_carpi_ulnaris: {
      en: "Flexor Carpi Ulnaris, FCU",
      ko: "자쪽손목굽힘근"
    },
    flexor_digitorum_super_cialis: {
      en: "Flexor Digitorum Superficialis",
      ko: "얕은손가락굽힘근"
    }
  };

  const [deepMuscleFrontCheckedItems, setDeepMuscleFrontCheckedItems] = useState({
    pronator_quadratus: true,
    flexor_digitorum_profundus: true,
    flexor_pollicis_longus: true,

  })

  const deepfrontmuscleNames = {
    pronator_quadratus: {
      en: "Pronator Quadratus Muscle",
      ko: "네모엎침근"
    },
    flexor_digitorum_profundus: {
      en: "Flexor Digitorum Profundus",
      ko: "깊은손가락굽힌근"
    },
    flexor_pollicis_longus: {
      en: "Flexor Pollicis Longus, FPL",
      ko: "긴엄지굽힘근"
    }
  };

  const [superficialMuscleBackCheckedItems, setSuperficialMuscleBackCheckedItems] = useState({
    extensor_digitorum: true,
    extensor_digiti_minimi: true,
    extensor_carpi_ulnaris: true,
    brachialis_muscle: true,
    extensor_carpi_radialis_longus: true,
    extensor_carpi_radialis_brevis: true,

  })

  const superficialbackmuscleNames = {
    extensor_digitorum: {
      en: "Extensor Digitorum Muscle",
      ko: "손가락폄근"
    },
    extensor_digiti_minimi: {
      en: "Extensor Digiti Minimi",
      ko: "새끼폄근"
    },
    extensor_carpi_ulnaris: {
      en: "Extensor Carpi Ulnaris",
      ko: "자쪽손목폄근"
    },
    brachialis_muscle: {
      en: "Brachioradialis Muscle",
      ko: "위팔노근"
    },
    extensor_carpi_radialis_longus: {
      en: "Extensor Carpi Radialis Longus",
      ko: "긴노쪽손목폄근"
    },
    extensor_carpi_radialis_brevis: {
      en: "Extensor Carpi Radialis Brevis",
      ko: " 짧은노쪽손목폄근"
    },

  };

  const [deepMuscleBackCheckedItems, setDeepMuscleBackCheckedItems] = useState({
    supinator: true,
    extensor_indices: true,
    abductor_pollicis_longus: true,
    extensor_pollicis_brevis: true,
    extensor_pollicis_longus: true,

  })

  const deepbackmuscleNames = {
    supinator: {
      en: "Supinator Muscle",
      ko: "손뒤침근"
    },
    extensor_indices: {

      en: "Extensor Indices [Proprius]",
      ko: "집게폄근"
    },
    abductor_pollicis_longus: {
      en: "Abductor Pollicis Longus, APL",
      ko: "긴엄지벌림근"
    },
    extensor_pollicis_brevis: {
      en: "Extensor Pollicis Brevis, EPB",
      ko: "짧은엄지폄근"
    },
    extensor_pollicis_longus: {
      en: "Extensor Pollicis Longus Muscle, EPL",
      ko: "긴엄지폄근"
    },

  };
  const [allPaused, setAllPaused] = useState({
    "Hand Grasping": false,
    "Left-Right Movement With Palm Open": false,
    "Left-Right Movement With Fist Closed": false,
    "Up-Down Movement With Palm Open": false,
    "Up-Down Movement With Fist Closed": false,
  });
  // State to track if all are paused
  const muscleList = [
    { en: 'Hand Grasping', ko: '손 잡기' },
    { en: 'Left-Right Movement With Palm Open', ko: '손바닥을 연 상태에서 좌우 이동' },
    { en: 'Left-Right Movement With Fist Closed', ko: '주먹을 쥐고 좌우 이동' },
    { en: 'Up-Down Movement With Palm Open', ko: '팜 오픈 시 상하 이동' },
    { en: 'Up-Down Movement With Fist Closed', ko: '주먹을 쥐고 상하운동' },
  ];
  const handlePlayPause2 = (muscleName, activerow) => {
    const key = `${muscleName}:${activerow}`;

    // Update both playingVideos and allPaused together
    setPlayingVideos((prevPlayingVideos) => {
      const updatedPlayingVideos = {};

      // Set all videos to false
      Object.keys(prevPlayingVideos).forEach((k) => {
        updatedPlayingVideos[k] = false;
      });

      // Set the current key to true
      updatedPlayingVideos[key] = !prevPlayingVideos[key];

      // Prepare updated allPaused
      const updatedAllPaused = {};
      Object.keys(prevPlayingVideos).forEach((k) => {
        const [muscle] = k.split(":"); // Extract muscle name from key
        updatedAllPaused[muscle] = false; // Reset all to false
      });
      updatedAllPaused[muscleName] = updatedPlayingVideos[key]; // Set current muscle's state

      // Dispatch actions synchronously
      dispatch(addMuscleName(muscleName));
      dispatch(addIsPlaying(updatedPlayingVideos[key]));
      dispatch(addAllPaused(updatedAllPaused));

      // Update allPaused state
      setAllPaused(updatedAllPaused);

      return updatedPlayingVideos;
    });
  };


  useEffect(() => {
    if (allPaused) {
      setSelectedMuscleGroup('')
      dispatch(addSelectedMuscleGroup({
        superficial_front_forearm: true,
        deep_front_forearm: true,
        superficial_back_forearm: true,
        deep_back_forearm: true,
        muscles_thumb: true,
        muscles_palm: true,
        deep_muscles_palm: true,
      }));
      dispatch(addActiveMuscleRow(''))
      setSuperficialFrontActiveRow(null);
      setDeepMuscleFrontActiveRow(null);
      setSuperficialBackActiveRow(null);
      setDeepMuscleBackActiveRow(null);
      setThumbMusclesActiveRow(null);
      setPalmMusclesActiveRow(null);
      setDeepPalmMuscleActiveRow(null);
      setSelectAllSuperficialFront(true);
      setSuperficialMuscleFrontCheckedItems({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      })
      dispatch(addSuperficialFrontForearmVisibility({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      }))
      // }
      setSelectAllDeepFront(true)
      setDeepMuscleFrontCheckedItems({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      })
      dispatch(addDeepFrontForearmVisibility({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      }))

      setSelectAllSuperficialBack(true)
      setSuperficialMuscleBackCheckedItems({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      })
      dispatch(addSuperficialBackForearmVisibility({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      }))
      setSelectAllDeepBack(true)
      setDeepMuscleBackCheckedItems({
        supinator: true,
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,

      })
      dispatch(addDeepBackForearmVisibility({
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,
      }))
      setSelectAllThumb(true)
      setThumbMuscleCheckedItems({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      })
      dispatch(addMuscleThumbVisibility({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      }))
      setSelectAllPalm(true)
      setPalmMuscleCheckedItems({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,

      })
      dispatch(addMusclePalmVisibility({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,
      }))
      setSelectAllDeepPalm(true)
      setDeepPalmMuscleCheckedItems({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      })
      dispatch(addDeepMusclePalm({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      }))
    }

  }, [allPaused])
  const [thumbMuscleCheckedItems, setThumbMuscleCheckedItems] = useState({
    opponens_pollicis: true,
    flexor_pollicis_brevis: true,
    abductor_pollicis_brevis: true,
    abductor_pollicis: true,

  })

  const thumbmuscleNames = {
    opponens_pollicis: {
      en: "Opponens Pollicis",
      ko: "엄지맞섬근"
    },
    flexor_pollicis_brevis: {
      en: "Flexor Pollicis Brevis",
      ko: "짧은엄지굽힘근"
    },
    abductor_pollicis_brevis: {
      en: "Abductor Pollicis Brevis",
      ko: "짧은엄지벌림근"
    },
    abductor_pollicis: {
      en: "Adductor Pollicis Muscle",
      ko: "엄지모음근"
    },

  };

  const [palmMuscleCheckedItems, setPalmMuscleCheckedItems] = useState({
    palmaris_brevis: true,
    abductor_digiti_minimi: true,
    flexor_digiti_minimi_brevis: true,
    opponens_digiti_minimi: true,


  })

  const palmmuscleNames = {

    opponens_digiti_minimi: {
      en: "Opponens Digiti Minimi",
      ko: "새끼맞섬근"
    },
    abductor_digiti_minimi: {
      en: "Abductor Digiti Minimi",
      ko: "새끼벌림근"
    },
    flexor_digiti_minimi_brevis: {
      en: "Flexor Digiti Minimi Brevis",
      ko: "짧은새끼굽힘근"
    },
    palmaris_brevis: {
      en: "Palmaris Brevis",
      ko: "짧은손바닥근"
    },


  };

  const [deepPalmMuscleCheckedItems, setDeepPalmMuscleCheckedItems] = useState({
    lumbricals: true,
    dorsal_interrosei: true,
    palmar_interossei: true,

  })

  const deeppalmmuscleNames = {
    lumbricals: {
      en: "Lumbricals",
      ko: "벌레근"
    },
    dorsal_interrosei: {
      en: "Dorsal Interrosei, DI",
      ko: "등쪽뼈사이근"
    },
    palmar_interossei: {
      en: "Palmar Interossei",
      ko: "바닥쪽뼈사이근"
    },

  };

  const [selectedMuscleGroup, setSelectedMuscleGroup] = useState("");
  const leftrightbutton = useSelector((state) => state.CommonReducer.leftrightbutton);

  //handle condition for basic mode and area selection mode
  const handleButtonClick = useCallback((button) => {
    setActiveButton(button);
    setShowModal(false);
    setIsTipsClicked(false);
    dispatch(addSideBarActiveButton(button));
    if (button == 'basicmode') {
      dispatch(addMuscleName(''))
      dispatch(addBasicModeSubMuscle({
        deep_back_forearm: {
          Abductor_Pollicis_Longus: true,
          Extensor_Indices: true,
          Extensor_Pollicis_Brevis: true,
          Extensor_Pollicis_Longus_Muscle: true,
          Supinator_Muscle: true,
        },
        deep_front_forearm: {
          Flexor_Digitorum_Profundus: true,
          Flexor_Pollicis_Longus: true,
          Pronator_Quadratus_Muscle: true,
        },
        deep_muscles_palm: {
          Dorsal_Interrosei: true,
          Lumbricals: true,
          Palmar_Interossei: true,
        },
        muscles_palm: {
          Abductor_Digiti_Minimi: true,
          Flexor_Digiti_Minimi_Brevis: true,
          Opponens_Digiti_Minimi: true,
          Palmaris_Brevis: true,
        },
        muscles_thumb: {
          Adductor_Pollicis_Muscle: true,
          Abductor_Pollicis_Brevis: true,
          Flexor_Pollicis_Brevis: true,
          Opponens_Pollicis: true,
        },
        superficial_back_forearm: {
          Brachioradialis_Muscle: true,
          Extensor_Carpi_Radialis_Brevis: true,
          Extensor_Carpi_Radialis_Longus: true,
          Extensor_Carpi_Ulnaris: true,
          Extensor_Digiti_Minimi: true,
          Extensor_Digitorum_Muscle: true,
        },
        superficial_front_forearm: {
          Flexor_Carpi_Radialis: true,
          Flexor_Carpi_Ulnaris: true,
          Flexor_Digitorum_Superficialis: true,
          Palmaris_Longus: true,
          Pronator_Teres: true,
        }
      }));
      dispatch(addSideBarActiveState(false))
      setSelectAll1(true);
      setMuscleCheckedItems(() => {
        const initialState = {};
        Object.keys(muscleContent).forEach((key) => {
          const musclesState = {};
          muscleContent[key].muscles.forEach((muscle) => {
            muscle.en = muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim();
            musclesState[muscle.en] = true;
          });
          initialState[key] = musclesState;
        });
        return initialState;
      })
      setCheckedItems(() => {
        const initialState = {};
        Object.keys(muscleContent).forEach((key) => {
          initialState[key] = true;
        });
        return initialState;
      })

    }
    setTimeout(() => {
      if (button == 'areaselectionmode') {
        dispatch(addSideBarActiveState(true))
      }
    }, 0);
    if (button === 'areaselectionmode') {
      dispatch(addMuscleName(''))

      setSuperficialFrontActiveRow(null);
      setDeepMuscleFrontActiveRow(null);
      setSuperficialBackActiveRow(null);
      setDeepMuscleBackActiveRow(null);
      setThumbMusclesActiveRow(null);
      setPalmMusclesActiveRow(null);
      setDeepPalmMuscleActiveRow(null);
      setSelectAllSuperficialFront(true);
      setSuperficialMuscleFrontCheckedItems({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      })
      dispatch(addSuperficialFrontForearmVisibility({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      }))
      // }
      setSelectAllDeepFront(true)
      setDeepMuscleFrontCheckedItems({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      })
      dispatch(addDeepFrontForearmVisibility({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      }))

      setSelectAllSuperficialBack(true)
      setSuperficialMuscleBackCheckedItems({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      })
      dispatch(addSuperficialBackForearmVisibility({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      }))
      setSelectAllDeepBack(true)
      setDeepMuscleBackCheckedItems({
        supinator: true,
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,

      })
      dispatch(addDeepBackForearmVisibility({
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,
      }))
      setSelectAllThumb(true)
      setThumbMuscleCheckedItems({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      })
      dispatch(addMuscleThumbVisibility({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      }))
      setSelectAllPalm(true)
      setPalmMuscleCheckedItems({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,

      })
      dispatch(addMusclePalmVisibility({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,
      }))
      setSelectAllDeepPalm(true)
      setDeepPalmMuscleCheckedItems({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      })
      dispatch(addDeepMusclePalm({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      }))
    }


  }, [setActiveButton, dispatch,]);

  useEffect(() => {


    if (activeButton == 'basicmode') {
      dispatch(addBasicModeSubMuscle({
        deep_back_forearm: {
          Abductor_Pollicis_Longus: true,
          Extensor_Indices: true,
          Extensor_Pollicis_Brevis: true,
          Extensor_Pollicis_Longus_Muscle: true,
          Supinator_Muscle: true,
        },
        deep_front_forearm: {
          Flexor_Digitorum_Profundus: true,
          Flexor_Pollicis_Longus: true,
          Pronator_Quadratus_Muscle: true,
        },
        deep_muscles_palm: {
          Dorsal_Interrosei: true,
          Lumbricals: true,
          Palmar_Interossei: true,
        },
        muscles_palm: {
          Abductor_Digiti_Minimi: true,
          Flexor_Digiti_Minimi_Brevis: true,
          Opponens_Digiti_Minimi: true,
          Palmaris_Brevis: true,
        },
        muscles_thumb: {
          Adductor_Pollicis_Muscle: true,
          Abductor_Pollicis_Brevis: true,
          Flexor_Pollicis_Brevis: true,
          Opponens_Pollicis: true,
        },
        superficial_back_forearm: {
          Brachioradialis_Muscle: true,
          Extensor_Carpi_Radialis_Brevis: true,
          Extensor_Carpi_Radialis_Longus: true,
          Extensor_Carpi_Ulnaris: true,
          Extensor_Digiti_Minimi: true,
          Extensor_Digitorum_Muscle: true,
        },
        superficial_front_forearm: {
          Flexor_Carpi_Radialis: true,
          Flexor_Carpi_Ulnaris: true,
          Flexor_Digitorum_Superficialis: true,
          Palmaris_Longus: true,
          Pronator_Teres: true,
        }
      }));
      dispatch(addSideBarActiveState(false))
      setSelectAll1(true);
      setMuscleCheckedItems(() => {
        const initialState = {};
        Object.keys(muscleContent).forEach((key) => {
          const musclesState = {};
          muscleContent[key].muscles.forEach((muscle) => {
            muscle.en = muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim();
            musclesState[muscle.en] = true;
          });
          initialState[key] = musclesState;
        });
        return initialState;
      })
      setCheckedItems(() => {
        const initialState = {};
        Object.keys(muscleContent).forEach((key) => {
          initialState[key] = true;
        });
        return initialState;
      })
    }
    setTimeout(() => {
      if (activeButton == 'areaselectionmode') {
        dispatch(addSideBarActiveState(true))
      }
    }, 0);
    if (activeButton === 'areaselectionmode') {
      setSuperficialFrontActiveRow(null);
      setDeepMuscleFrontActiveRow(null);
      setSuperficialBackActiveRow(null);
      setDeepMuscleBackActiveRow(null);
      setThumbMusclesActiveRow(null);
      setPalmMusclesActiveRow(null);
      setDeepPalmMuscleActiveRow(null);
      setSelectAllSuperficialFront(true);
      setSuperficialMuscleFrontCheckedItems({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      })
      dispatch(addSuperficialFrontForearmVisibility({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      }))
      // }
      setSelectAllDeepFront(true)
      setDeepMuscleFrontCheckedItems({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      })
      dispatch(addDeepFrontForearmVisibility({
        pronator_quadratus: true,
        flexor_digitorum_profundus: true,
        flexor_pollicis_longus: true,
      }))

      setSelectAllSuperficialBack(true)
      setSuperficialMuscleBackCheckedItems({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      })
      dispatch(addSuperficialBackForearmVisibility({
        extensor_digitorum: true,
        extensor_digiti_minimi: true,
        extensor_carpi_ulnaris: true,
        brachialis_muscle: true,
        extensor_carpi_radialis_longus: true,
        extensor_carpi_radialis_brevis: true,
      }))
      setSelectAllDeepBack(true)
      setDeepMuscleBackCheckedItems({
        supinator: true,
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,

      })
      dispatch(addDeepBackForearmVisibility({
        extensor_indices: true,
        abductor_pollicis_longus: true,
        extensor_pollicis_brevis: true,
        extensor_pollicis_longus: true,
      }))
      setSelectAllThumb(true)
      setThumbMuscleCheckedItems({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      })
      dispatch(addMuscleThumbVisibility({
        opponens_pollicis: true,
        flexor_pollicis_brevis: true,
        abductor_pollicis_brevis: true,
        abductor_pollicis: true,

      }))
      setSelectAllPalm(true)
      setPalmMuscleCheckedItems({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,
      })
      dispatch(addMusclePalmVisibility({
        palmaris_brevis: true,
        abductor_digiti_minimi: true,
        flexor_digiti_minimi_brevis: true,
        opponens_digiti_minimi: true,
      }))
      setSelectAllDeepPalm(true)
      setDeepPalmMuscleCheckedItems({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      })
      dispatch(addDeepMusclePalm({
        lumbricals: true,
        dorsal_interrosei: true,
        palmar_interossei: true,

      }))
    }
    setAllPaused({
      "Hand Grasping": false,
      "Left-Right Movement With Palm Open": false,
      "Left-Right Movement With Fist Closed": false,
      "Up-Down Movement With Palm Open": false,
      "Up-Down Movement With Fist Closed": false,
    })
    dispatch(addAllPaused({
      "Hand Grasping": false,
      "Left-Right Movement With Palm Open": false,
      "Left-Right Movement With Fist Closed": false,
      "Up-Down Movement With Palm Open": false,
      "Up-Down Movement With Fist Closed": false,
    }));


  }, [leftrightbutton])


  //handle of basic mode
  const handleCheckboxSelectChange1 = (event) => {
    const checked = event.target.checked;
    // console.log('Select All Checkbox Clicked');

    setSelectAll1(checked);

    const updatedCheckedItems = Object.keys(checkedItems).reduce((acc, key) => {
      acc[key] = checked;
      return acc;
    }, {});

    const updatedMuscleCheckedItems = Object.keys(muscleContent).reduce((acc, muscleKey) => {
      const updatedMuscleGroup = {};
      muscleContent[muscleKey].muscles.forEach((muscle) => {
        const muscleName = muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim();
        updatedMuscleGroup[muscleName] = checked;
      });
      acc[muscleKey] = updatedMuscleGroup;
      return acc;
    }, {});

    setCheckedItems(updatedCheckedItems);
    setMuscleCheckedItems(updatedMuscleCheckedItems);
    dispatch(addBasicMode(updatedCheckedItems));
  };


  //handle of superficial muscle front forearm
  const handleSuperficialCheckboxChange = (event) => {
    const { name, checked } = event.target;
    // console.log('name', name, checked)
    const updatedCheckedItems = { ...superficialMuscleFrontCheckedItems, [name]: checked };
    // console.log('updatedCheckedItems', updatedCheckedItems)
    dispatch(addSuperficialFrontForearmVisibility(updatedCheckedItems))
    setSuperficialMuscleFrontCheckedItems(updatedCheckedItems);


    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    // console.log('allChecked', allChecked)
    setSelectAllSuperficialFront(allChecked);
  };

  const handleCheckboxSelectChange2 = (event) => {
    const checked = event.target.checked;

    switch (selectedMuscleGroup) {
      case 'superficial_front_forearm':
        const updatedSuperficialFrontItems = Object.keys(superficialMuscleFrontCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setSuperficialMuscleFrontCheckedItems(updatedSuperficialFrontItems);
        dispatch(addSuperficialFrontForearmVisibility(updatedSuperficialFrontItems));
        setSelectAllSuperficialFront(checked);
        break;

      case 'deep_front_forearm':
        const updatedDeepFrontItems = Object.keys(deepMuscleFrontCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setDeepMuscleFrontCheckedItems(updatedDeepFrontItems);
        dispatch(addDeepFrontForearmVisibility(updatedDeepFrontItems));
        setSelectAllDeepFront(checked);
        break;

      case 'superficial_back_forearm':
        const updatedSuperficialBackItems = Object.keys(superficialMuscleBackCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setSuperficialMuscleBackCheckedItems(updatedSuperficialBackItems);
        dispatch(addSuperficialBackForearmVisibility(updatedSuperficialBackItems));
        setSelectAllSuperficialBack(checked);
        break;

      case 'deep_back_forearm':
        const updatedDeepBackItems = Object.keys(deepMuscleBackCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setDeepMuscleBackCheckedItems(updatedDeepBackItems);
        dispatch(addDeepBackForearmVisibility(updatedDeepBackItems));
        setSelectAllDeepBack(checked);
        break;

      case 'muscles_thumb':
        const updatedThumbItems = Object.keys(thumbMuscleCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setThumbMuscleCheckedItems(updatedThumbItems);
        dispatch(addMuscleThumbVisibility(updatedThumbItems));
        setSelectAllThumb(checked);
        break;

      case 'muscles_palm':
        const updatedPalmItems = Object.keys(palmMuscleCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setPalmMuscleCheckedItems(updatedPalmItems);
        dispatch(addMusclePalmVisibility(updatedPalmItems));
        setSelectAllPalm(checked);
        break;

      case 'deep_muscles_palm':
        const updatedDeepPalmItems = Object.keys(deepPalmMuscleCheckedItems).reduce((acc, key) => {
          acc[key] = checked;
          return acc;
        }, {});
        setDeepPalmMuscleCheckedItems(updatedDeepPalmItems);
        dispatch(addDeepMusclePalm(updatedDeepPalmItems));
        setSelectAllDeepPalm(checked);
        break;

      default:
        break;
    }
  };

  const handleDeepMuscleFrontCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...deepMuscleFrontCheckedItems, [name]: checked };
    dispatch(addDeepFrontForearmVisibility(updatedCheckedItems))
    setDeepMuscleFrontCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllDeepFront(allChecked);
  };

  const handleSuperficialMuscleBackCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...superficialMuscleBackCheckedItems, [name]: checked };
    dispatch(addSuperficialBackForearmVisibility(updatedCheckedItems))
    setSuperficialMuscleBackCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllSuperficialBack(allChecked);
  };

  const handleDeepMuscleBackCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...deepMuscleBackCheckedItems, [name]: checked };
    dispatch(addDeepBackForearmVisibility(updatedCheckedItems))
    setDeepMuscleBackCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllDeepBack(allChecked);
  };

  const handleThumbMuscleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...thumbMuscleCheckedItems, [name]: checked };
    dispatch(addMuscleThumbVisibility(updatedCheckedItems))
    setThumbMuscleCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllThumb(allChecked);
  };

  const handlePalmMuscleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...palmMuscleCheckedItems, [name]: checked };
    dispatch(addMusclePalmVisibility(updatedCheckedItems))
    setPalmMuscleCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllPalm(allChecked);
  };

  const handleDeepPalmMuscleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    const updatedCheckedItems = { ...deepPalmMuscleCheckedItems, [name]: checked };
    dispatch(addDeepMusclePalm(updatedCheckedItems))
    setDeepPalmMuscleCheckedItems(updatedCheckedItems);

    const allChecked = Object.values(updatedCheckedItems).every(item => item);
    setSelectAllDeepPalm(allChecked);
  };


  const handleSelect = (eventKey) => {
    // console.log("Selected key:", eventKey);
    // Reset the active row once the muscle group changed
    if (eventKey !== previousMuscleGroup) {
      setSuperficialFrontActiveRow(null);
      setDeepMuscleFrontActiveRow(null);
      setSuperficialBackActiveRow(null);
      setDeepMuscleBackActiveRow(null);
      setThumbMusclesActiveRow(null);
      setPalmMusclesActiveRow(null);
      setDeepPalmMuscleActiveRow(null);
      setSelectAllSuperficialFront(true);
      setSuperficialMuscleFrontCheckedItems({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      })
      dispatch(addSuperficialFrontForearmVisibility({
        pronator_teres: true,
        flexor_carpi_radialis: true,
        palmar_longus_muscle: true,
        flexor_carpi_ulnaris: true,
        flexor_digitorum_super_cialis: true

      }))
    }
    setSelectAllDeepFront(true)
    setDeepMuscleFrontCheckedItems({
      pronator_quadratus: true,
      flexor_digitorum_profundus: true,
      flexor_pollicis_longus: true,
    })
    dispatch(addDeepFrontForearmVisibility({
      pronator_quadratus: true,
      flexor_digitorum_profundus: true,
      flexor_pollicis_longus: true,
    }))

    setSelectAllSuperficialBack(true)
    setSuperficialMuscleBackCheckedItems({
      extensor_digitorum: true,
      extensor_digiti_minimi: true,
      extensor_carpi_ulnaris: true,
      brachialis_muscle: true,
      extensor_carpi_radialis_longus: true,
      extensor_carpi_radialis_brevis: true,
    })
    dispatch(addSuperficialBackForearmVisibility({
      extensor_digitorum: true,
      extensor_digiti_minimi: true,
      extensor_carpi_ulnaris: true,
      brachialis_muscle: true,
      extensor_carpi_radialis_longus: true,
      extensor_carpi_radialis_brevis: true,
    }))
    setSelectAllDeepBack(true)
    setDeepMuscleBackCheckedItems({
      supinator: true,
      extensor_indices: true,
      abductor_pollicis_longus: true,
      extensor_pollicis_brevis: true,
      extensor_pollicis_longus: true,

    })
    dispatch(addDeepBackForearmVisibility({
      extensor_indices: true,
      abductor_pollicis_longus: true,
      extensor_pollicis_brevis: true,
      extensor_pollicis_longus: true,
    }))
    setSelectAllThumb(true)
    setThumbMuscleCheckedItems({
      opponens_pollicis: true,
      flexor_pollicis_brevis: true,
      abductor_pollicis_brevis: true,
      abductor_pollicis: true,

    })
    dispatch(addMuscleThumbVisibility({
      opponens_pollicis: true,
      flexor_pollicis_brevis: true,
      abductor_pollicis_brevis: true,
      abductor_pollicis: true,

    }))
    setSelectAllPalm(true)
    setPalmMuscleCheckedItems({
      palmaris_brevis: true,
      abductor_digiti_minimi: true,
      flexor_digiti_minimi_brevis: true,
      opponens_digiti_minimi: true,
    })
    dispatch(addMusclePalmVisibility({
      palmaris_brevis: true,
      abductor_digiti_minimi: true,
      flexor_digiti_minimi_brevis: true,
      opponens_digiti_minimi: true,
    }))
    setSelectAllDeepPalm(true)
    setDeepPalmMuscleCheckedItems({
      lumbricals: true,
      dorsal_interrosei: true,
      palmar_interossei: true,

    })
    dispatch(addDeepMusclePalm({
      lumbricals: true,
      dorsal_interrosei: true,
      palmar_interossei: true,

    }))

    setSelectedMuscleGroup(eventKey);
    setPreviousMuscleGroup(eventKey);

    setCheckedItems2((prevCheckedItems) => {
      const updatedCheckedItems = { ...prevCheckedItems };

      Object.keys(updatedCheckedItems).forEach((key) => {
        updatedCheckedItems[key] = key === eventKey;
      });
      dispatch(addSelectedMuscleGroup(updatedCheckedItems));
      return updatedCheckedItems;
    });
  };



  //movements 
  const movements = {
    superficial_muscle_front_forearm: {
      pronator_teres: {
        en: 'Forearm Pronation',
        ko: '팔꿈치 회내',
      },
      flexor_carpi_radialis: {
        en: 'Wrist Flexion, Wrist Radial Deviation',
        ko: '손목 굴곡, 손목 요측 편위',
      },
      palmar_longus_muscle: {
        en: 'Wrist Flexion',
        ko: '손목 굴곡',
      },
      flexor_carpi_ulnaris: {
        en: 'Wrist Flexion, Wrist Ulnar Deviation',
        ko: '손목 굴곡, 손목 척측 편위',
      },
      flexor_digitorum_super_cialis: {
        en: 'Fingers Flexion',
        ko: '손가락 굴곡',
      },
    },
    deep_muscle_front_forearm: {
      pronator_quadratus: {
        en: 'Forearm Pronation',
        ko: '팔꿈치 회내',
      },
      flexor_digitorum_profundus: {
        en: 'Wrist Flexion, Fingers Flexion',
        ko: '손목 굴곡, 손가락 굴곡',
      },
      flexor_pollicis_longus: {
        en: 'Thumb Flexion',
        ko: '엄지 굴곡',
      },
    },
    superficial_muscle_back_forearm: {
      extensor_digitorum: {
        en: 'Finger Extension',
        ko: '손가락 신전',
      },
      extensor_digiti_minimi: {
        en: 'Little Finger Extension',
        ko: '새끼 손가락 신전',
      },
      extensor_carpi_ulnaris: {
        en: 'Wrist Extension, Wrist Radial Deviation',
        ko: '손목 신전, 손목 요측 편위',
      },
      brachialis_muscle: {
        en: 'Elbow Flexion',
        ko: '팔꿈치 굴곡',
      },
      extensor_carpi_radialis_longus: {
        en: 'Wrist Extension',
        ko: '손목 신전',
      },
      extensor_carpi_radialis_brevis: {
        en: 'Wrist Extension',
        ko: '손목 신전',
      },

    },
    deep_muscle_back_forearm: {
      supinator: {
        en: 'Supination',
        ko: '외전',
      },
      extensor_indices: {
        en: 'Index Finger Extension',
        ko: '검지 손가락 신전',
      },
      abductor_pollicis_longus: {
        en: 'Thumb Abduction',
        ko: '엄지 벌림',
      },
      extensor_pollicis_brevis: {
        en: 'Thumb Extension',
        ko: '엄지 신전',
      },
      extensor_pollicis_longus: {
        en: 'Full Thumb Extension',
        ko: '완전한 엄지 신전',
      },

    },
    thumb_muscles: {
      opponens_pollicis: {
        en: 'Thumb Opposition',
        ko: '엄지 대립',
      },
      flexor_pollicis_brevis: {
        en: 'Thumb Flexion',
        ko: '엄지 굴곡',
      },
      abductor_pollicis_brevis: {
        en: 'Thumb Abduction',
        ko: '엄지 벌림',
      },
      abductor_pollicis: {
        en: 'Thumb Adduction',
        ko: '엄지 모음',
      },

    },
    palm_muscles: {
      palmaris_brevis: {
        en: 'Cupping Of Hand',
        ko: '손의 구부림',
      },
      abductor_digiti_minimi: {
        en: 'Little Finger Abduction',
        ko: '새끼 손가락 벌림',
      },
      flexor_digiti_minimi_brevis: {
        en: 'Little Finger Flexion',
        ko: '새끼 손가락 굴곡',
      },

      opponens_digiti_minimi: {
        en: 'Little Finger Opposition',
        ko: '새끼 손가락 대립',
      },
    },
    deep_palm_muscles: {
      lumbricals: {
        en: 'Clawing Of Hand',
        ko: '손의 발가락',
      },
      dorsal_interrosei: {
        en: 'Cupping Of Hand',
        ko: '손의 구부림',
      },
      palmar_interossei: {
        en: 'Cupping Of Hand',
        ko: '손의 구부림',
      },

    },
  };


  //movements state declaration
  const [previousMuscleGroup, setPreviousMuscleGroup] = useState(null);
  const [superficialFrontActiveRow, setSuperficialFrontActiveRow] = useState(null);
  const [deepMuscleFrontActiveRow, setDeepMuscleFrontActiveRow] = useState(null);
  const [superficialBackActiveRow, setSuperficialBackActiveRow] = useState(null);
  const [deepMuscleBackActiveRow, setDeepMuscleBackActiveRow] = useState(null);
  const [thumbMusclesActiveRow, setThumbMusclesActiveRow] = useState(null);
  const [palmMusclesActiveRow, setPalmMusclesActiveRow] = useState(null);
  const [deepPalmMuscleActiveRow, setDeepPalmMuscleActiveRow] = useState(null);
  const [superficialFronts, setSelectAllSuperficialFronts] = useState(null);
  useEffect(() => {
    setPlayingVideos({});
  }, [
    superficialFrontActiveRow,
    superficialFronts,
    deepMuscleFrontActiveRow,
    superficialBackActiveRow,
    deepMuscleBackActiveRow,
    thumbMusclesActiveRow,
    palmMusclesActiveRow,
    deepPalmMuscleActiveRow,
    activeButton,
    leftrightbutton
  ]);
  const [previousMuscleGroups, setPreviousMuscleGroups] = useState(null);
  const [superficialFrontActiveRows, setSuperficialFrontActiveRows] = useState(null);
  const [deepMuscleFrontActiveRows, setDeepMuscleFrontActiveRows] = useState(null);
  const [superficialBackActiveRows, setSuperficialBackActiveRows] = useState(null);
  const [deepMuscleBackActiveRows, setDeepMuscleBackActiveRows] = useState(null);
  const [thumbMusclesActiveRows, setThumbMusclesActiveRows] = useState(null);
  const [palmMusclesActiveRows, setPalmMusclesActiveRows] = useState(null);
  const [deepPalmMuscleActiveRows, setDeepPalmMuscleActiveRows] = useState(null);



  //movements handle button condition
  const handleSuperficialFrontActiveRowRowClick = (rowId, value) => {
    // console.log('rowId', rowId, value)
    setSuperficialFrontActiveRow(rowId);
    dispatch(addActiveMuscleRow(rowId))

  };

  const handleDeepMuscleFrontActiveRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setDeepMuscleFrontActiveRow(rowId);
  };

  const handleSuperficialBackActiveRowRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setSuperficialBackActiveRow(rowId);
  };

  const handleDeepMuscleBackActiveRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setDeepMuscleBackActiveRow(rowId);
  };

  const handleThumbMusclesActiveRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setThumbMusclesActiveRow(rowId);
  };

  const handlePalmMusclesActiveRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setPalmMusclesActiveRow(rowId);
  };

  const handleDeepPalmMusclesActiveRowClick = (rowId) => {
    dispatch(addActiveMuscleRow(rowId))
    setDeepPalmMuscleActiveRow(rowId);
  };


  //  find the English name from the Korean name
  const getEnglishName = (koreanName) => {
    // console.log("Searching for:", koreanName);
    for (const group in movements) {
      for (const muscle in movements[group]) {
        // console.log("Checking:", movements[group][muscle].ko);
        if (movements[group][muscle].ko.includes(koreanName.trim())) {
          const englishNames = movements[group][muscle].en.split(', ');
          for (const englishName of englishNames) {
            if (movements[group][muscle].ko.split(', ').indexOf(koreanName.trim()) === englishNames.indexOf(englishName)) {
              return englishName;
            }
          }
        }
      }
    }
    return koreanName;
  };



  //handle video playing 
  const handlePlayPause = (muscleName, activerow) => {
    // console.log("hshaaaaa", muscleName)
    const key = `${muscleName}:${activerow}`;

    setPlayingVideos((prevPlayingVideos) => {

      const isPlaying = prevPlayingVideos[key];

      const updatedPlayingVideos = Object.keys(prevPlayingVideos).reduce((acc, key) => {
        acc[key] = false;
        return acc;
      }, {});

      updatedPlayingVideos[key] = !isPlaying;

      dispatch(addMuscleName(muscleName));
      dispatch(addIsPlaying(!isPlaying));

      // if (!isPlaying) {
      //   updateSliderProgress(muscleName, activerow);
      // }

      return updatedPlayingVideos;
    });
  };

  const progressWidth = (musclePlay, activerow) => {
    // console.log('prgresssssssssssssssssssssssssss', musclePlay, activerow)
    if (musclePlay === 'Forearm Pronation' && activerow === 'pronator_teres') {
      return setprogressplaypause.ForearmPronation;
    } else if (musclePlay === 'Wrist Flexion' && activerow === 'flexor_carpi_radialis') {
      return setprogressplaypause.WristFlexion;
    } else if (musclePlay === 'Wrist Radial Deviation' && activerow === 'flexor_carpi_radialis') {
      return setprogressplaypause.WristRadialDeviation;
    } else if (musclePlay === 'Wrist Flexion' && activerow === 'palmar_longus_muscle') {
      return setprogressplaypause.PLMWristFlexion;
    } else if (musclePlay === 'Wrist Flexion' && activerow === 'flexor_carpi_ulnaris') {
      return setprogressplaypause.FCUWristFlexion;
    } else if (musclePlay === 'Wrist Ulnar Deviation' && activerow === 'flexor_carpi_ulnaris') {
      return setprogressplaypause.FCUWristUlnarDeviation;
    } else if (musclePlay === 'Fingers Flexion' && activerow === 'flexor_digitorum_super_cialis') {
      return setprogressplaypause.FDSFingersFlexion;
    } else if (musclePlay === 'Forearm Pronation' && activerow === 'pronator_quadratus') {
      return setprogressplaypause.PQForearmPronation;
    } else if (musclePlay === 'Wrist Flexion' && activerow === 'flexor_digitorum_profundus') {
      return setprogressplaypause.FDPWristFlexion;
    } else if (musclePlay === 'Fingers Flexion' && activerow === 'flexor_digitorum_profundus') {
      return setprogressplaypause.FDPFingersFlexion;
    } else if (musclePlay === 'Thumb Flexion' && activerow === 'flexor_pollicis_longus') {
      return setprogressplaypause.FPLThumbFlexion;
    }
    else if (musclePlay === 'Elbow Flexion' && activerow === 'brachialis_muscle') {
      return setprogressplaypause.BrachialisElbowFlexion;
    }
    else if (musclePlay === 'Finger Extension' && activerow === 'extensor_digitorum') {
      return setprogressplaypause.EDFingerExtension;
    }
    else if (musclePlay === 'Wrist Extension' && activerow === 'extensor_carpi_ulnaris') {
      return setprogressplaypause.ECUWristExtensionExtensorcarpiulnaris;
    }
    else if (musclePlay === 'Wrist Radial Deviation' && activerow === 'extensor_carpi_ulnaris') {
      return setprogressplaypause.ECUWristRadialDeviation;
    }
    else if (musclePlay === 'Wrist Extension' && activerow === 'extensor_carpi_radialis_longus') {
      return setprogressplaypause.ECRLWristExtension;
    }
    else if (musclePlay === 'Wrist Extension' && activerow === 'extensor_carpi_radialis_brevis') {
      return setprogressplaypause.ECRBWristExtension;
    }
    else if (musclePlay === 'Little Finger Extension' && activerow === 'extensor_digiti_minimi') {
      return setprogressplaypause.EDMLittleFingerExtension;
    }
    else if (musclePlay === 'Index Finger Extension' && activerow === 'extensor_indices') {
      return setprogressplaypause.EIIndexFingerExtension;
    }
    else if (musclePlay === 'Thumb Abduction' && activerow === 'abductor_pollicis_longus') {
      return setprogressplaypause.APLThumbAbduction;
    }
    else if (musclePlay === 'Thumb Extension' && activerow === 'extensor_pollicis_brevis') {
      return setprogressplaypause.EPBThumbExtensionMetacarpal;
    }
    else if (musclePlay === 'Full Thumb Extension' && activerow === 'extensor_pollicis_longus') {
      return setprogressplaypause.EPLThumbExtensionFullThumb;
    }
    else if (musclePlay === 'Thumb Opposition' && activerow === 'opponens_pollicis') {
      return setprogressplaypause.OPThumbOpposition;
    }
    else if (musclePlay === 'Thumb Abduction' && activerow === 'abductor_pollicis_brevis') {
      return setprogressplaypause.APBThumbAbductionAbductorPollicisBrevis;
    }
    else if (musclePlay === 'Thumb Adduction' && activerow === 'abductor_pollicis') {
      return setprogressplaypause.APThumbAdduction;
    }
    else if (musclePlay === 'Thumb Flexion' && activerow === 'flexor_pollicis_brevis') {
      return setprogressplaypause.FPBThumbAdductionThumbFlexionFlexorPollicisBrevis;
    }
    else if (musclePlay === 'Little Finger Opposition' && activerow === 'opponens_digiti_minimi') {
      return setprogressplaypause.ODMLittleFingerOpposition;
    }
    else if (musclePlay === 'Little Finger Abduction' && activerow === 'abductor_digiti_minimi') {
      return setprogressplaypause.ADMLittleFingerAbduction;
    }
    else if (musclePlay === 'Little Finger Flexion' && activerow === 'flexor_digiti_minimi_brevis') {
      return setprogressplaypause.FDMLittleFingerFlexion;
    }
    else if (musclePlay === 'Clawing Of Hand' && activerow === 'lumbricals') {
      return setprogressplaypause.LStraightFingerFlexion;
    }
    else if (musclePlay === 'Cupping Of Hand' && activerow === 'palmaris_brevis') {
      return setprogressplaypause.PBCuppingofHandPalmarisBrevis;
    }
    else if (musclePlay === 'Cupping Of Hand' && activerow === 'dorsal_interrosei') {
      return setprogressplaypause.DICuppingofHand;
    }
    else if (musclePlay === 'Cupping Of Hand' && activerow === 'palmar_interossei') {
      return setprogressplaypause.PICuppingofHand;
    }
    else if (musclePlay === 'Supination' && activerow === 'supinator') {
      return setprogressplaypause.Supinator;
    }
    else if (musclePlay === 'Left-Right Movement With Palm Open') {
      return setprogressplaypause.LeftRightPalmopen
    }
    else if (musclePlay === 'Hand Grasping') {
      return setprogressplaypause.HandGrasping
    }
    else if (musclePlay === 'Left-Right Movement With Fist Closed') {
      return setprogressplaypause.LeftRightFistClosed
    }
    else if (musclePlay === 'Up-Down Movement With Palm Open') {
      return setprogressplaypause.UpDownPalmopen
    }
    else if (musclePlay === 'Up-Down Movement With Fist Closed') {
      return setprogressplaypause.UpDownFistClosed
    }



    else {
      return 0;
    }
  };

  // Handle slider changes
  const handleSliderChange = (muscleName, activerow, newValue) => {
    // console.log('munisg', newValue)
    const key = `${muscleName}:${activerow}`;
    dispatch(addSliderChangevalue(newValue));
    dispatch(addMuscleName(muscleName))
    dispatch(addIsPlaying(false))
    setPlayingVideos({})
    setAllPaused({
      "Hand Grasping": false,
      "Left-Right Movement With Palm Open": false,
      "Left-Right Movement With Fist Closed": false,
      "Up-Down Movement With Palm Open": false,
      "Up-Down Movement With Fist Closed": false,
    })
    // If the video is playing, sync its progress
    if (playingVideos[key]) {
      const videoElement = document.getElementById(key);
      if (videoElement) {
        const videoDuration = videoElement.duration;
        const newTime = (newValue / 100) * videoDuration;
        videoElement.currentTime = newTime;
      }
    }
  };


  // handle click for tips
  const handleClickTips = () => {
    setShowModal(true);
    setIsTipsClicked(true);
  }

  useEffect(() => {
    if (activeButton === 'basicmode') {
      setAllPaused({
        "Hand Grasping": false,
        "Left-Right Movement With Palm Open": false,
        "Left-Right Movement With Fist Closed": false,
        "Up-Down Movement With Palm Open": false,
        "Up-Down Movement With Fist Closed": false,
      })
      dispatch(addAllPaused({
        "Hand Grasping": false,
        "Left-Right Movement With Palm Open": false,
        "Left-Right Movement With Fist Closed": false,
        "Up-Down Movement With Palm Open": false,
        "Up-Down Movement With Fist Closed": false,
      }));

      setImageSrc(images.tips1);
      setTipsContent({
        en: [
          "Muscles can be observed by rotating the screen using the mouse",
          "Zoom in and out using Ctrl + scroll control",
          "Click on a muscle to find its name",
        ],
        ko: [
          "근육은 마우스를 사용하여 화면을 회전시켜 관찰할 수 있습니다",
          "Ctrl + 스크롤을 사용하여 확대 및 축소할 수 있습니다",
          "근육을 클릭하면 이름을 찾을 수 있습니다",
        ]
      });
    } else if (activeButton === 'areaselectionmode') {
      setAllPaused({
        "Hand Grasping": false,
        "Left-Right Movement With Palm Open": false,
        "Left-Right Movement With Fist Closed": false,
        "Up-Down Movement With Palm Open": false,
        "Up-Down Movement With Fist Closed": false,
      })
      dispatch(addAllPaused({
        "Hand Grasping": false,
        "Left-Right Movement With Palm Open": false,
        "Left-Right Movement With Fist Closed": false,
        "Up-Down Movement With Palm Open": false,
        "Up-Down Movement With Fist Closed": false,
      }));

      setImageSrc(images.tips2);
      setTipsContent({
        en: [
          "Choose the muscle group from the dropdown menu",
          <>Click on the name of the muscle to see the list<br /> of animations below</>,
          <>Click play to see the animations or drag<br /> the slider</>,
          <>You can toggle the visibility of the muscles by unchecking <br />the checkboxes</>
        ],
        ko: [
          "드롭다운 메뉴에서 근육 그룹을 선택하세요",
          <>근육의 이름을 클릭하면 아래의 애니메이션 목록을<br /> 볼 수 있습니다</>,
          <>재생 버튼을 클릭하여 애니메이션을<br /> 보거나 슬라이더를 드래그하세요</>,
          <>체크박스를 선택 해제하여 근육의 가시성을 전환할 수<br /> 있습니다</>
        ]
      });
    }
  }, [activeButton]);

  const handleClose = () => {
    // console.log('Modal closed');
    setShowModal(false);
    setIsTipsClicked(false);
  };


  // Toggle dropdown function
  const handleToggleDropdowns = (key) => {
    setDropdownOpen((prev) => ({
      ...prev,
      [key]: !prev[key] // Toggle the current dropdown
    }));
  };

  // Initial state with all checkboxes (main and sub) set to true
  const [checkedItems, setCheckedItems] = useState(() => {
    const initialState = {};
    Object.keys(muscleContent).forEach((key) => {
      initialState[key] = true;
    });
    return initialState;
  });

  const [muscleCheckedItems, setMuscleCheckedItems] = useState(() => {
    const initialState = {};
    Object.keys(muscleContent).forEach((key) => {
      const musclesState = {};
      muscleContent[key].muscles.forEach((muscle) => {
        muscle.en = muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim();
        musclesState[muscle.en] = true;
      });
      initialState[key] = musclesState;
    });
    return initialState;
  });

  // Function to handle the main group checkbox change
  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;

    // setCheckedItems((prev) => ({
    //   ...prev,
    //   [name]: checked,
    // }));

    setCheckedItems((prev) => {
      const newCheckedItems = {
        ...prev,
        [name]: checked,
      };


      // Check if all checkboxes are checked
      const allChecked = Object.values(newCheckedItems).every((item) => item);
      setSelectAll1(allChecked);

      return newCheckedItems;
    });

    // Set all sub-checkboxes (muscles) to the same value as the main group checkbox
    setMuscleCheckedItems((prev) => {
      const updatedMuscleItems = {};
      muscleContent[name].muscles.forEach((muscle) => {
        muscle.en = muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim()
        updatedMuscleItems[muscle.en] = checked;
      });
      return {
        ...prev,
        [name]: updatedMuscleItems,
      };
    });
  };

  // Function to handle individual muscle checkbox change
  const handleMuscleCheckboxChange = (muscleKey, muscleItem) => {
    setMuscleCheckedItems((prev) => {
      const updatedMuscleGroup = {
        ...prev[muscleKey],
        [muscleItem]: !prev[muscleKey][muscleItem]
      };
      const allMusclesChecked = Object.values(updatedMuscleGroup).every((checked) => checked);

      setCheckedItems((prevChecked) => {
        const updatedCheckedItems = {
          ...prevChecked,
          [muscleKey]: allMusclesChecked,
        };

        const allGroupsChecked = Object.values(updatedCheckedItems).every((item) => item);
        setSelectAll1(allGroupsChecked);

        return updatedCheckedItems;
      });

      return {
        ...prev,
        [muscleKey]: updatedMuscleGroup,
      };
    });
  };

  useEffect(() => {
    dispatch(addBasicModeSubMuscle(muscleCheckedItems));
  }, [muscleCheckedItems]);

  return (
    <div className='app_sidebar vh-100'>
      <div className="main-container">
        <CSidebar className='sidebar_container'>
          <CSidebarHeader className='sidebar_header'>
            <div className="left-panel" style={{ backgroundImage: `url(${images.main_bg_1})` }}>
              <div className={`content-container ${showModal ? 'position-abosulute' : ""}`}>
                <div className="centered-content">
                  <div className="toggle-image">
                    <img src={images.toggel_bg} alt="Toggle" />
                  </div>
                  <div className="button-group-wrapper">
                    <div className="button-group-1" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
                      <button
                        className={activeButton === 'basicmode' ? 'active' : 'non-active'}
                        onClick={() => handleButtonClick('basicmode')}
                      >{language === 'en' ? 'Basic Mode' : '기본 모드'}
                      </button>
                      <button
                        className={activeButton === 'areaselectionmode' ? 'active' : 'non-active'}
                        onClick={() => handleButtonClick('areaselectionmode')}
                      >{language === 'en' ? 'Expert Mode' : '전문가 모드'}
                      </button>
                    </div>
                  </div>
                </div>
                {/* Basic Mode Section */}
                {activeButton === 'basicmode' && (
                  <div className="sectionBascimode" style={{ pointerEvents: loading ? 'none' : 'auto' }}>
                    <div className="bottom-section-1">
                      <div className="bottom-row">
                        <label htmlFor="selectAll1" className="bottom-text custom-checkbox-container text-light-white">
                          {(language === 'en' ? 'Select All' : '모두 선택')}
                          <input
                            type="checkbox"
                            name="selectAll1"
                            className="checkbox-div-selectAll"
                            checked={selectAll1}
                            onChange={handleCheckboxSelectChange1}
                          />
                        </label>
                      </div>

                      <div className="bottom-content">
                        {/* Muscle Group Dropdowns */}
                        {Object.keys(muscleContent).map((key) => (
                          <div key={key}>
                            {/* Dropdown Toggle for Each Muscle Group */}
                            <div className="bottom-row">
                              <label htmlFor={key} className="bottom-text custom-checkbox-container text-light-white">
                                {muscleContent[key].names[language]}

                                {/* Dropdown Toggle Icon */}
                                <div className="dopchk">
                                  <button
                                    className="dropdown-icon-button ss"
                                    onClick={() => handleToggleDropdowns(key)}
                                  >
                                    <span>{dropdownOpen[key] ? '-' : '+'}</span>
                                  </button>
                                  <input
                                    type="checkbox"
                                    id={key}
                                    name={key}
                                    className="checkbox-div"
                                    checked={checkedItems[key]}
                                    onChange={handleCheckboxChange}
                                  />
                                  <span className="custom-checkbox"></span>
                                </div>
                              </label>
                            </div>

                            {/* Dropdown Content with Checkboxes (Shown only when clicked) */}
                            {dropdownOpen[key] && (
                              <div className="bs-dropdown-content">
                                {muscleContent[key].muscles.map((muscle) => (
                                  <label key={muscle.en} className="bottom-text custom-checkbox-container text-light-white vblo">
                                    {muscle[language].replace(/_/g, ' ')}
                                    <input
                                      type="checkbox"
                                      className=""
                                      checked={muscleCheckedItems[key]?.[muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim()] || false}
                                      onChange={() => handleMuscleCheckboxChange(key, muscle.en.replace(/\[.*?\]/g, '').split(',')[0].trim())}
                                    />
                                  </label>
                                ))}
                              </div>
                            )}

                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}



                {activeButton === 'areaselectionmode' && (
                  <div className="sectionareaselectionmode">
                    <div>
                      <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                        {language === 'en' ? 'Movements of the Hand' : '손의 움직임'}
                      </label>
                      <div className="bottom-content" >
                        {muscleList.map((muscle, index) => {
                          const muscleName = language === 'en' ? muscle.en : muscle.ko;
                          const englishMuscleName = muscle.en; // Used for keys and play/pause logic
                          return (
                            <div key={`${englishMuscleName}-${index}`}>
                              <div>
                                <div className="sub-muscle-play-mode">
                                  <div className="d-flex align-items-center justify-content-between">
                                    <label className="bottom-text custom-checkbox-container text-light-white">{muscleName}</label>
                                    <button
                                      className="d-flex align-items-center gap-15"
                                      onClick={() => handlePlayPause2(englishMuscleName, index)}
                                    >
                                      <FontAwesomeIcon
                                        icon={allPaused[englishMuscleName] ? faPause : faPlay}
                                        style={{
                                          color: allPaused[englishMuscleName] ? '#7244BC' : 'white', // Set color for Pause/Play icon
                                        }}
                                      />
                                      <span
                                        style={{
                                          color: allPaused[englishMuscleName] ? '#7244BC' : 'white', // Set color for Pause/Play text
                                        }}
                                      >
                                        {allPaused[englishMuscleName]
                                          ? language === 'en'
                                            ? 'Pause'
                                            : '일시정지'
                                          : language === 'en'
                                            ? 'Play'
                                            : '재생'}
                                      </span>

                                    </button>
                                  </div>
                                  <div className="progress-barr">
                                    <input
                                      type="range"
                                      value={progressWidth(englishMuscleName, index)}
                                      onChange={(e) => handleSliderChange(englishMuscleName, index, e.target.value)}
                                    />
                                  </div>
                                </div>
                                <hr className="bottom-divider" />
                              </div>
                            </div>
                          );
                        })}
                      </div>

                    </div>

                    <div className={`dropdown-container ${Object.values(allPaused).every((paused) => paused === false) ? 'disabled' : ''}`}
                      style={{
                        pointerEvents: Object.values(allPaused).every((paused) => paused === false) ? 'auto' : 'none',
                        opacity: Object.values(allPaused).every((paused) => paused === false) ? 1 : 0.8,
                      }}>
                      <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                        {language === 'en' ? 'Muscle Group' : '근육 그룹'}
                      </label>
                      <Dropdown onSelect={handleSelect}>
                        <Dropdown.Toggle
                          id="muscle-group"
                          className={`dropdown-select ${!selectedMuscleGroup ? 'dropdown-label-clr' : 'dropdown-items-clr'}`}>
                          {selectedMuscleGroup ? muscleNames[selectedMuscleGroup][language] : (language === 'en' ? 'Choose Muscle Group' : '근육 그룹 선택')}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {Object.keys(muscleNames).map((key) => (
                            <Dropdown.Item
                              key={key}
                              eventKey={key}
                              active={key === selectedMuscleGroup}
                            >
                              {muscleNames[key][language]}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                      {selectedMuscleGroup && (
                        <div>
                          <div className="bottom-row pl-0">
                            <label for="selectAllSuperficialFront" className="bottom-text custom-checkbox-container text-light-white">
                              {(language === 'en' ? 'Select All' : '모두 선택')}
                              <input
                                type="checkbox"
                                name="selectAllSuperficialFront"
                                className="checkbox-div-selectAll"
                                checked={
                                  selectedMuscleGroup === 'superficial_front_forearm' ? selectAllSuperficialFront :
                                    selectedMuscleGroup === 'deep_front_forearm' ? selectAllDeepFront :
                                      selectedMuscleGroup === 'superficial_back_forearm' ? selectAllSuperficialBack :
                                        selectedMuscleGroup === 'deep_back_forearm' ? selectAllDeepBack :
                                          selectedMuscleGroup === 'muscles_thumb' ? selectAllThumb :
                                            selectedMuscleGroup === 'muscles_palm' ? selectAllPalm :
                                              selectedMuscleGroup === 'deep_muscles_palm' ? selectAllDeepPalm :
                                                false
                                }
                                onChange={handleCheckboxSelectChange2}
                              />
                            </label>
                          </div>
                        </div>
                      )}
                      {selectedMuscleGroup === 'superficial_front_forearm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(superficialMuscleFrontCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${superficialFrontActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleSuperficialFrontActiveRowRowClick(key, superficialMuscleFrontCheckedItems[key])}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {superficialmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={superficialMuscleFrontCheckedItems[key]}
                                  onChange={handleSuperficialCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {(selectedMuscleGroup === 'superficial_front_forearm' && superficialFrontActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.superficial_muscle_front_forearm[superficialFrontActiveRow] &&
                            movements.superficial_muscle_front_forearm[superficialFrontActiveRow][language].split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${superficialFrontActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, superficialFrontActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${superficialFrontActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${superficialFrontActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          {/* <div className="progress" style={{ width: `${progressWidth(englishMuscleName, superficialFrontActiveRow)}%` }}></div> */}
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, superficialFrontActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, superficialFrontActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )
                          }
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_front_forearm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(deepMuscleFrontCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${deepMuscleFrontActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleDeepMuscleFrontActiveRowClick(key)}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {deepfrontmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={deepMuscleFrontCheckedItems[key]}
                                  onChange={handleDeepMuscleFrontCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_front_forearm' && (deepMuscleFrontActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.deep_muscle_front_forearm[deepMuscleFrontActiveRow] &&
                            movements.deep_muscle_front_forearm[deepMuscleFrontActiveRow][language]
                              .split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${deepMuscleFrontActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, deepMuscleFrontActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${deepMuscleFrontActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${deepMuscleFrontActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, deepMuscleFrontActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, deepMuscleFrontActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )
                          }
                        </div>
                      )}
                      {selectedMuscleGroup === 'superficial_back_forearm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(superficialMuscleBackCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${superficialBackActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleSuperficialBackActiveRowRowClick(key)}>

                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {superficialbackmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={superficialMuscleBackCheckedItems[key]}
                                  onChange={handleSuperficialMuscleBackCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'superficial_back_forearm' && (superficialBackActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.superficial_muscle_back_forearm[superficialBackActiveRow] &&
                            movements.superficial_muscle_back_forearm[superficialBackActiveRow][language]
                              .split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${superficialBackActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, superficialBackActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${superficialBackActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${superficialBackActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, superficialBackActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, superficialBackActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )}
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_back_forearm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(deepMuscleBackCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${deepMuscleBackActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleDeepMuscleBackActiveRowClick(key)}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {deepbackmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={deepMuscleBackCheckedItems[key]}
                                  onChange={handleDeepMuscleBackCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_back_forearm' && (deepMuscleBackActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.deep_muscle_back_forearm[deepMuscleBackActiveRow] &&
                            movements.deep_muscle_back_forearm[deepMuscleBackActiveRow][language]
                              .split(',')
                              // .filter(musclePlay => musclePlay.trim() !== '')f
                              // .map((musclePlay) => (
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${deepMuscleBackActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, deepMuscleBackActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${deepMuscleBackActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${deepMuscleBackActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, deepMuscleBackActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, deepMuscleBackActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )
                            // )
                          }
                        </div>
                      )}
                      {selectedMuscleGroup === 'muscles_thumb' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(thumbMuscleCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${thumbMusclesActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleThumbMusclesActiveRowClick(key)}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {thumbmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={thumbMuscleCheckedItems[key]}
                                  onChange={handleThumbMuscleCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'muscles_thumb' && (thumbMusclesActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.thumb_muscles[thumbMusclesActiveRow] &&
                            movements.thumb_muscles[thumbMusclesActiveRow][language]
                              .split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${thumbMusclesActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, thumbMusclesActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${thumbMusclesActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${thumbMusclesActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, thumbMusclesActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, thumbMusclesActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )}
                        </div>
                      )}
                      {selectedMuscleGroup === 'muscles_palm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(palmMuscleCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${palmMusclesActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handlePalmMusclesActiveRowClick(key)}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {palmmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={palmMuscleCheckedItems[key]}
                                  onChange={handlePalmMuscleCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'muscles_palm' && (palmMusclesActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.palm_muscles[palmMusclesActiveRow] &&
                            movements.palm_muscles[palmMusclesActiveRow][language]
                              .split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${palmMusclesActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, palmMusclesActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${palmMusclesActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${palmMusclesActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, palmMusclesActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, palmMusclesActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )}
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_muscles_palm' && (
                        <div className="bottom-content area-selectionmode-checkitms">
                          {Object.keys(deepPalmMuscleCheckedItems).map((key) => (
                            <div key={key} className="d-flex custom-checkbox-container">
                              <div className={`bottom-row sub-muscle ${deepPalmMuscleActiveRow === key ? 'active-row' : ''}`}
                                onClick={() => handleDeepPalmMusclesActiveRowClick(key)}
                              >
                                <div className="bottom-text custom-checkbox-container text-light-white">
                                  {deeppalmmuscleNames[key][language]}
                                </div>
                              </div>
                              <div className="pxy810">
                                <input
                                  type="checkbox"
                                  id={key}
                                  name={key}
                                  className="checkbox-div-selectAll"
                                  checked={deepPalmMuscleCheckedItems[key]}
                                  onChange={handleDeepPalmMuscleCheckboxChange}
                                />
                              </div>
                              <hr className="bottom-divider" />
                            </div>
                          ))}
                        </div>
                      )}
                      {selectedMuscleGroup === 'deep_muscles_palm' && (deepPalmMuscleActiveRow &&
                        <div className="area-selectionmode-movements">
                          <label htmlFor="muscle-group" className="dropdown-label text-light-white text-align-left">
                            {(language === 'en' ? 'Movements' : '행동')}
                          </label>
                          {movements.deep_palm_muscles[deepPalmMuscleActiveRow] &&
                            movements.deep_palm_muscles[deepPalmMuscleActiveRow][language]
                              .split(',')
                              .map((musclePlay, index) => {
                                const englishMuscleName = getEnglishName(musclePlay.trim());
                                return (
                                  <div className="bottom-content" key={`${englishMuscleName}-${deepPalmMuscleActiveRow}`}>
                                    <div >
                                      <div className="sub-muscle-play-mode">
                                        <div className="d-flex align-items-center justify-content-between">
                                          <label className="custom-checkbox-container text-light-white">{musclePlay}
                                          </label>
                                          <button className="d-flex align-items-center gap-15" onClick={() => handlePlayPause(englishMuscleName, deepPalmMuscleActiveRow)}>
                                            <FontAwesomeIcon icon={playingVideos[`${englishMuscleName}:${deepPalmMuscleActiveRow}`] ? faPause : faPlay} />
                                            <span>{playingVideos[`${englishMuscleName}:${deepPalmMuscleActiveRow}`]
                                              ? (language === 'en' ? 'Pause' : '일시정지')
                                              : (language === 'en' ? 'Play' : '재생')}
                                            </span>
                                          </button>
                                        </div>
                                        <div className="progress-barr">
                                          <input
                                            type="range"
                                            // min='0'
                                            // max="100"
                                            // step="0."
                                            // className={progressWidth(englishMuscleName, superficialFrontActiveRow)>1?'progress':''}
                                            value={progressWidth(englishMuscleName, deepPalmMuscleActiveRow)}
                                            onChange={(e) => handleSliderChange(englishMuscleName, deepPalmMuscleActiveRow, e.target.value)}
                                          />
                                        </div>
                                      </div>
                                      <hr className="bottom-divider" />
                                    </div>
                                  </div>
                                )
                              }
                              )}
                        </div>
                      )}
                    </div>

                  </div>
                )}
                <div className="bottom-section-2">
                  <div className={`bottom-content2 ${showModal ? 'no-background' : ''}`}>
                    <div className={`tips-container ${showModal ? 'text-img-none' : ""}`} onClick={handleClickTips}>
                      <img src={images.tip_icon} className="tip-icon" alt="Tips" />
                      <button className="tips-text">
                        {language === 'en' ? 'Tips' : '팁'}
                      </button>
                    </div>
                  </div>
                </div>
                {isTipsClicked && <TipsModal show={showModal} imageSrc={imageSrc} onClose={handleClose} tipsContent={tipsContent} activeButton={activeButton} />}
              </div>
            </div>
          </CSidebarHeader>
        </CSidebar>
      </div>
    </div >
  );
};

export default SideBarActivity;
